import { useTranslation } from 'react-i18next'
import NumberFormat from 'react-number-format'
import { NumberParts } from './Input/NumberParts'

interface NumberFormatCustomProps {
  inputRef: (instance: NumberFormat<number | string> | null) => void
  onChange: (e) => void
  name: string
  decimalScale?: number
  fixedDecimalScale?: boolean
}

function NumberFormatCustom(props: NumberFormatCustomProps) {
  const { inputRef, onChange, ...other } = props

  const { i18n } = useTranslation()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const value = (other as any)?.value?.value
    ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (other as any)?.value?.value
    : // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (other as any)?.value

  return (
    <NumberFormat
      {...other}
      value={value}
      // defaultValue={props.value}
      getInputRef={inputRef}
      onValueChange={(values, sourceInfo) => {
        if (sourceInfo.source === 'event') {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
            currentTarget: {
              name: props.name,
              value: values.floatValue,
            },
          })
        }
      }}
      thousandSeparator={NumberParts(i18n.language, 'group')}
      decimalSeparator={NumberParts(i18n.language, 'decimal')}
      allowLeadingZeros={false}
      decimalScale={props.decimalScale ?? 2}
      fixedDecimalScale={props.fixedDecimalScale ?? true}
      isNumericString
    />
  )
}

export { NumberFormatCustom }
